import * as React from 'react';
import { times } from 'lodash';

import {
	Wrapper,
	Title,
	Value,
	Header,
	HeaderLabel,
	ColName,
	ColValue,
	TotalColValue,
	Row,
	Box,
	List,
} from './styles';

export const ListBox = props => {
	const {
		total,
		colors,
		data,
		isTopItem,
		selectedCompanies,
		renderContextualMenu,
	} = props;

	const companiesLength = selectedCompanies.length;

	return (
		<Wrapper>
			<Box isTopItem={isTopItem}>
				<Title>{total.categoryName}</Title>
				<Value>{total.value}</Value>
			</Box>

			{data && (
				<List>
					<Header>
						<ColName companiesLength={companiesLength} />
						<TotalColValue>Total</TotalColValue>
						{times(companiesLength, index => (
							<ColValue key={index + colors[index]}>
								<HeaderLabel style={{ background: colors[index] }} />
							</ColValue>
						))}
					</Header>

					{data.map((dataItem, index) => (
						<Row key={index}>
							{renderContextualMenu && renderContextualMenu(dataItem, index)}

							<ColName companiesLength={companiesLength}>
								{dataItem.categoryName}
							</ColName>
							{dataItem.values.map((value, index) => (
								<ColValue key={index + value}>{value}</ColValue>
							))}
						</Row>
					))}
				</List>
			)}
		</Wrapper>
	);
};
